import {flow, get, isEmpty, isNil, negate} from 'lodash/fp';
import {createSelector} from 'reselect';

import {getCacheKey} from '/util/records.util';
import {fromProps} from '/util/selector.util';

import {search as searchState} from './root.selector';

function isNotSearchable(input: any) {
  return input.length < 3;
}

export const allSearchResults = createSelector(
  searchState,
  get('allSearchResults'),
);
export const searchInput = createSelector(searchState, get('searchInput'));

export const hasSearchInput = createSelector(
  searchInput,
  negate(isNotSearchable),
);

export const searchResultsBySearchInput = createSelector(
  searchInput,
  allSearchResults,
  fromProps(get('recordsParams')),
  (input, meta, recordsParams) =>
    get(
      getCacheKey({
        recordsName: input,
        recordsParams: {filterBy: recordsParams?.filterBy, filterByValue: ''},
      }),
    )(meta),
);

export const hasSearchResultsBySearchInput = createSelector(
  searchResultsBySearchInput,
  negate(isNil),
);

export const allSearchMeta = createSelector(searchState, get('allSearchMeta'));

export const allSearchMetaBySearchInput = createSelector(
  searchInput,
  allSearchMeta,
  fromProps(get('recordsParams')),
  (input, meta, recordsParams) =>
    get(
      getCacheKey({
        recordsName: input,
        recordsParams: {filterBy: recordsParams?.filterBy, filterByValue: ''},
      }),
    )(meta),
);

export const searchResultsSizeBySearchInput = createSelector(
  allSearchMetaBySearchInput,
  flow([
    get('size'),
    (size: any) => {
      if (isNil(size)) {
        return undefined;
      } else {
        return parseInt(size, 10);
      }
    },
  ]),
);

export const isEndReachedBySearchInput = createSelector(
  allSearchMetaBySearchInput,
  get('isEndReached'),
);

export const isLoadingBySearchInput = createSelector(
  allSearchMetaBySearchInput,
  get('isLoading'),
);

export const recentSearches = createSelector(
  searchState,
  get('recentSearches'),
);

export const hasRecentSearches = createSelector(
  recentSearches,
  negate(isEmpty),
);
